//customGet eliminate the chances of treating null as a value , not just null but it handles

import { get } from 'lodash';
import moment from 'moment';

// all the falsy value which you generally don't expect and have any use on ui
export const customGet = (object, path, defaultValue) => {
  const value = get(object, path);
  return value || defaultValue;
};

export const formatDate = (date, upto = 5) => {
  const showAgoUpTo5Days = moment().diff(moment(date), 'days') <= upto;
  return showAgoUpTo5Days ? moment.utc(date).local().fromNow() : moment.utc(date).format('ll');
};

export const setGlobalVariable = (data) => {
  // Global context of DAP for embedded web components
  if (!window.__dapadmin__) window.__dapadmin__ = {};
  const globalVariable = { ...window.__dapadmin__, ...data };
  window.__dapadmin__ = globalVariable;
  return;
};

export const getGlobalVariable = (key) => {
  if (!key && window.__dapadmin__) return window.__dapadmin__;
  if (key && window.__dapadmin__ && window.__dapadmin__[key]) return window.__dapadmin__[key];
  return false;
};

export const childRoute = () => {
  return window.location.pathname.split('/standard-etl')[1];
};
